var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.footerShow)?_c('div',[_c('Footer',{attrs:{"routerPath":_vm.routerPath}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }